import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class Alvikfarbsensorlabel extends ASTBlock {
    constructor(color) {
        super(color, "alvik_farbsensor_label")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "Farbe des Bodensensors %1",
            "args0": [{
                "type": "input_dummy",
                "name": "NAME"
            }],
            "output": "String"
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}